import {
  SocialButton
} from "../chunk-TY4DM4QD.mjs";
import "../chunk-7CU25RIV.mjs";

// src/social-buttons/social-button-facebook.tsx
import * as React from "react";
import { systemForwardRef } from "@stepstone-genesis/system";
import { FacebookLoginColouredIcon } from "@stepstone-genesis/icons";
var SocialFacebookButton = systemForwardRef(function SocialFacebookButton2({ children, ...props }, ref) {
  var _a;
  const defaultLabel = "Log in with Facebook";
  return /* @__PURE__ */ React.createElement(
    SocialButton,
    {
      ref,
      element: "SOCIAL_FACEBOOK_BUTTON",
      ...props,
      iconBefore: /* @__PURE__ */ React.createElement(FacebookLoginColouredIcon, null),
      a11yLabel: (_a = props.a11yLabel) != null ? _a : defaultLabel
    },
    children != null ? children : defaultLabel
  );
});
export {
  SocialFacebookButton
};
